"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameosReasonId = exports.CameosReasonId_ReasonId = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/**
 * We wrap ReasonId around a message definition so multiple enums
 * can share the same enum names.
 */
var CameosReasonId_ReasonId;
(function (CameosReasonId_ReasonId) {
    /** REASON_UNSET - Default report reason for unset reasons */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["REASON_UNSET"] = 0] = "REASON_UNSET";
    /** WHY_MYSELF_IN_CAMEO - The user wants to know why their selfie was used in the story. */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["WHY_MYSELF_IN_CAMEO"] = 1] = "WHY_MYSELF_IN_CAMEO";
    /** GENDER_MISMATCH - User's selfie was used for a character of the wrong gender in Cameo. */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["GENDER_MISMATCH"] = 2] = "GENDER_MISMATCH";
    /** UNKNOWN_FRIEND - User does not know the person on the Cameo. */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["UNKNOWN_FRIEND"] = 3] = "UNKNOWN_FRIEND";
    /** DONT_LIKE_WANT_TO_SEE - Reporter does not like or want to see the reported data */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["DONT_LIKE_WANT_TO_SEE"] = 4] = "DONT_LIKE_WANT_TO_SEE";
    /** INAPPROPRIATE - Reported data contains inappropriate content in general */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["INAPPROPRIATE"] = 5] = "INAPPROPRIATE";
    /** TECHNICAL_ISSUE - User encountered a technical problem. */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["TECHNICAL_ISSUE"] = 6] = "TECHNICAL_ISSUE";
    /** OTHER - Others issues which user want to report. */
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["OTHER"] = 7] = "OTHER";
    CameosReasonId_ReasonId[CameosReasonId_ReasonId["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CameosReasonId_ReasonId = exports.CameosReasonId_ReasonId || (exports.CameosReasonId_ReasonId = {}));
function createBaseCameosReasonId() {
    return { reasonId: 0 };
}
exports.CameosReasonId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reasonId !== 0) {
            writer.uint32(8).int32(message.reasonId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCameosReasonId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reasonId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCameosReasonId();
        message.reasonId = object.reasonId ?? 0;
        return message;
    },
};
//# sourceMappingURL=cameos_reason_id.js.map